/* eslint-disable react/void-dom-elements-no-children */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import queryString from 'querystring';
import { GetTitle } from './boardTitle';
import { getBreadScrumb } from './breadscrumb';
import { GetTableFooter } from '../../_component/tableFooter';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';
import { BoardItem, BoardListItem, BoardReply } from './type/boardListItem';
import { Pagenation } from '../../_component/pagenation';

export function CreateBoardList(
  routeProps: RouteComponentProps,
  item: any,
  buttonLink: () => void,
  isFile: boolean
) {
  const dispatch = useDispatch();
  const [boardList, setBoardList] = useState<BoardListItem>();
  const [
    pageInfo = { total: 10, rowCount: 10, page: 1, totalPages: 1 },
    setPageInfo,
  ] = useState<any>();
  const [replys, setReplys] = useState<BoardReply>();
  const option: any = queryString.decode(routeProps.location.search.substring(1));

  const [searchSelect, setSearchSelect] = useState<string>('all');
  const [searchText, setSearchText] = useState<string>('');
  const history = useHistory();

  const options = [
    {
      value: 'all',
      name: '전체',
    },
    {
      value: 'subject',
      name: '제목',
    },
    {
      value: 'content',
      name: '내용',
    },
    {
      value: 'writer',
      name: '작성자',
    },
  ];
  // const onSearch = false;
  // let currentPage: number = 1;

  useEffect(() => {
    // if (option.page !== undefined) {
    //   // eslint-disable-next-line radix
    //   currentPage = Number.parseInt(option.page.toString());
    // }
    if (window.localStorage.getItem('token') === null && item.ctgy === 'qna') {
      dispatch(toast.error({ message: '로그인이 필요합니다.' }));
      history.push('/login');
    } else {
      getItems();
    }
  }, []);

  const getItems = async () => {
    if (searchText.length === 0) {
      await server
        .getBoardList(item.ctgy, pageInfo.page, 10)
        .then((payload) => {
          setBoardList(payload);
          const { meta } = payload;
          setPageInfo({
            total: meta.totalItems,
            rowCount: meta.itemsPerPage,
            page: meta.currentPage,
            totalPages: meta.totalPages,
          });
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else {
      // 검색창에 단어가 있을 때
      switch (searchSelect) {
        case 'subject':
          await server
            .searchBoardList(item.ctgy, 1, pageInfo.rowCount, searchText, '', '', '')
            .then((payload) => {
              setBoardList(payload);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              dispatch(
                toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
              );
              console.log(error);
            });
          break;
        case 'writer':
          await server
            .searchBoardList(item.ctgy, 1, pageInfo.rowCount, '', searchText, '', '')
            .then((payload) => {
              setBoardList(payload);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              dispatch(
                toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
              );
              console.log(error);
            });
          break;
        case 'content':
          await server
            .searchBoardList(item.ctgy, 1, pageInfo.rowCount, '', '', searchText, '')
            .then((payload) => {
              setBoardList(payload);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              dispatch(
                toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
              );
              console.log(error);
            });
          break;
        case 'all':
          await server
            .searchBoardList(item.ctgy, 1, pageInfo.rowCount, '', '', '', searchText)
            .then((payload) => {
              setBoardList(payload);
              // setMeta(payload.meta);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              dispatch(
                toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
              );
              console.log(error);
            });
          break;
        default:
          break;
      }
    }
  };

  const onClickPage = async (pageParam: any) => {
    // setCurrentPage(pageParam);
    if (searchText.length !== 0) {
      switch (searchSelect) {
        case 'subject':
          await server
            .searchBoardList(item.ctgy, pageParam.page, pageParam.rowCount, searchText, '', '', '')
            .then((payload) => {
              setBoardList(payload);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              dispatch(
                toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
              );
              console.log(error);
            });
          break;
        case 'writer':
          await server
            .searchBoardList(item.ctgy, pageParam.page, pageParam.rowCount, '', searchText, '', '')
            .then((payload) => {
              setBoardList(payload);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              dispatch(
                toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
              );
              console.log(error);
            });
          break;
        case 'content':
          await server
            .searchBoardList(item.ctgy, pageParam.page, pageParam.rowCount, '', '', searchText, '')
            .then((payload) => {
              setBoardList(payload);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              dispatch(
                toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
              );
              console.log(error);
            });
          break;
        case 'all':
          await server
            .searchBoardList(item.ctgy, pageParam.page, pageParam.rowCount, '', '', '', searchText)
            .then((payload) => {
              setBoardList(payload);
              const { meta } = payload;
              setPageInfo({
                total: meta.totalItems,
                rowCount: meta.itemsPerPage,
                page: meta.currentPage,
                totalPages: meta.totalPages,
              });
            })
            .catch((error) => {
              dispatch(
                toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
              );
              console.log(error);
            });
          break;
        default:
          break;
      }
    } else {
      await server
        .getBoardList(item.ctgy, pageParam.page, pageParam.rowCount)
        .then((payload) => {
          setBoardList(payload);
          const { meta } = payload;
          setPageInfo({
            total: meta.totalItems,
            rowCount: meta.itemsPerPage,
            page: meta.currentPage,
            totalPages: meta.totalPages,
          });
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  const getWriteButton = () => {
    return (
      <div className="view-footer">
        <button
          className="btn-sub"
          type="button"
          onClick={() => {
            const op = {
              ...option,
              ctgy: item.ctgy,
            };
            routeProps.history.push({
              pathname: '/board/boardWriter',
              search: `?${new URLSearchParams(op).toString()}`,
            });
          }}
        >
          글작성
        </button>
      </div>
    );
  };

  const onClickItem = (it: BoardItem, username: any) => {
    const i = {
      id: it.id,
      ctgy: item.ctgy,
      title: item.title,
      subTitle: item.subTitle,
    };

    routeProps.history.push({
      pathname: item.viewUrl, // '/board/boardView',
      search: `?${new URLSearchParams(i).toString()}`,
      state: {
        replie: item.replieButton,
        delete: item.deleteButton,
        update: item.updateButton,
        userId: username,
      },
    });
  };

  const getReply = (listItems: BoardItem[], depth: number) => {
    if (listItems === undefined) {
      return <></>;
    }
    const reply = `-${(depth / 10).toString()}${(depth % 10).toString()}`;
    const ret = [];
    for (let i = 0; i < listItems.length; i++) {
      const it = listItems[i];
      ret.push(
        <ul
          className="row"
          key={i}
          onClick={() => {
            const r = {
              id: it.id,
              ctgy: item.ctgy,
              title: item.title,
              subTitle: item.subTitle,
            };

            routeProps.history.push({
              pathname: '/board/replyView', // '/board/boardView',
              search: `?${new URLSearchParams(r).toString()}`,
              state: {
                replie: item.replieButton,
                delete: item.deleteButton,
                update: item.updateButton,
              },
            });
          }}
        >
          <li className="counter">{it.id}</li>
          <li className={`book-title reply ${depth > 1 ? reply : 'reply'}`}>{it.subject}</li>
          <li className="writer">{it.writer?.name || '구민사'}</li>
          <li className="date">{new Date(it.modDate).toLocaleDateString()}</li>
          <li className="views">{it.hit || '-'}</li>
          {isFile ? (
            <li className="files">
              <svg
                className="ico-file"
                xmlns="http://www.w3.org/2000/svg"
                height="18"
                viewBox="0 0 24 24"
                width="18"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" />
              </svg>
            </li>
          ) : (
            ''
          )}
        </ul>
      );
      ret.push(getReply(it.replies, depth + 1));
    }
    return <div>{ret}</div>;
  };

  const getList = (listItems: BoardListItem | undefined) => {
    if (listItems === undefined) {
      return <></>;
    }
    return (
      <div className="table">
        <ul className="row title">
          <li className="counter" defaultValue="번호">
            번호
          </li>
          <li className="book-title" defaultValue="제목">
            제목
          </li>
          <li className="writer" defaultValue="작성자">
            작성자
          </li>
          <li className="date" defaultValue="작성일">
            작성일
          </li>
          <li className="views" defaultValue="조회수">
            조회수
          </li>
          {isFile === false ? '' : <li className="files">파일</li>}
        </ul>
        {listItems.items.map((it: BoardItem) => (
          <div key={it.id}>
            <ul
              className="row"
              key={it.id}
              onClick={() => {
                onClickItem(it, it.writer?.username);
              }}
            >
              <li className="counter">{it.id}</li>
              <li className="book-title">{it.subject}</li>
              <li className="writer">{it.writer?.name}</li>
              <li className="date">{new Date(it.modDate).toLocaleDateString()}</li>
              <li className="views">{it.hit}</li>
              {isFile ? (
                <li className="files">
                  <svg
                    className="ico-file"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                    width="18"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" />
                  </svg>
                </li>
              ) : (
                ''
              )}
            </ul>
            {getReply(it.replies, 1)}
          </div>
        ))}
      </div>
    );
  };
  return (
    <>
      <>
        {getBreadScrumb(item.title, item.mainTitle === undefined ? '고객센터' : item.mainTitle)}
        <div className="title">
          <h2>{item.title}</h2>
          <p>{item.subTitle}</p>
        </div>
        <div className="table-header">
          <div className="search">
            <div className="selectbox">
              <select
                name=""
                id=""
                onChange={(e) => {
                  setSearchSelect(e.target.value);
                }}
              >
                {options.map((it) => (
                  <option value={it.value} key={it.value}>
                    {it.name}
                  </option>
                ))}
              </select>
            </div>
            <input
              type="search"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  getItems();
                }
              }}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              onClick={() => {
                // SearchTextFunction(searchText);
                // SelectSearchFunction(selectSearch);
                // searchFunction();
              }}
            >
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
          </div>
          {item.ctgy === 'qna' && getWriteButton()}
        </div>
      </>
      <>
        {getList(boardList)}
        {pageInfo ? (
          <Pagenation PageInfo={pageInfo} PagenationHandler={onClickPage} IsFirstEndArrow />
        ) : (
          ''
        )}
        {/* {GetTableFooter(
          boardList?.meta.currentPage,
          boardList?.meta.totalPages,
          (page: number) => {
            currentPage = page;

            getItems();
            const query = {
              page: page.toString(),
            };
            routeProps.history.push({
              pathname: `/board/${item.ctgy}`,
              search: `?${new URLSearchParams(query).toString()}`,
            });
          },
          item.buttonText,
          buttonLink,
          item.visableButton
        )} */}
      </>
    </>
  );
}
